import React from 'react';
import { AttachmentRow } from '@/components/AttachmentRow';
import type { Attachment } from '@/types/attachment';

const MAX_FULL_NAME_ATTACHMENTS = 2;

interface Props {
  attachments: Attachment[];
  isAlignedRight?: boolean;
  isFullWidth?: boolean;
  isColumnOnMobile?: boolean;
  onPreview: (attachment: Attachment) => void;
}

export const HomeTaskAttachments: React.FC<Props> = ({
  attachments,
  isAlignedRight = false,
  isFullWidth = false,
  isColumnOnMobile = false,
  onPreview,
}) => {
  const isCompact = attachments.length > MAX_FULL_NAME_ATTACHMENTS;
  const isSingleAttachment = attachments.length === 1;
  const fullNameClassName = isSingleAttachment
    ? 'w-fit max-w-full'
    : 'w-fit max-w-full md:max-w-[200px]';
  const rowClassName = isCompact ? 'w-[125px]' : fullNameClassName;

  if (!attachments.length) {
    return null;
  }

  if (isFullWidth && !isSingleAttachment) {
    return (
      <div className="grid grid-cols-2 gap-4 md:flex md:flex-wrap">
        {attachments.map((attachment) => (
          <AttachmentRow
            key={attachment.id}
            attachment={attachment}
            className="w-full md:w-fit md:max-w-[260px]"
            onPreview={onPreview}
          />
        ))}
      </div>
    );
  }

  return (
    <div
      className={`flex flex-wrap gap-3 ${isAlignedRight ? 'justify-end' : ''} ${isColumnOnMobile ? 'max-md:flex-col' : ''}`}
    >
      {attachments.map((attachment) => (
        <AttachmentRow
          key={attachment.id}
          attachment={attachment}
          className={`${rowClassName} ${isColumnOnMobile ? 'max-md:w-full' : ''}`}
          onPreview={onPreview}
        />
      ))}
    </div>
  );
};
